import { TopBar } from '@/layouts/TopBar';
import UsersList from '@/modules/users/components/UsersList';
import useUsers from '@/modules/users/hooks/useUsers';
import Paths from '@/routes/paths';
import { JButton } from '@atoms/JButton';
import { IconSize } from '@constants';
import { PlusIcon } from '@heroicons/react/24/outline';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const UsersPage = () => {
  const { t } = useTranslation();
  const { usersCount } = useUsers();
  const navigate = useNavigate();
  return (
    <>
      <TopBar title={t('USERS')} count={usersCount}>
        <JButton
          variant="contained"
          color="secondary"
          onClick={() => navigate(Paths.CreateUser)}
          startIcon={<PlusIcon color="#FFF" height={IconSize.buttonIcon} />}
        >
          {t('NEW_USER')}
        </JButton>
      </TopBar>
      <Box m={2}>
        <UsersList />
      </Box>
    </>
  );
};

export default UsersPage;
